import React from "react";
import icon1 from '../../media/images/icons/warranty.svg'
import icon2 from '../../media/images/icons/experts.svg'
import icon3 from '../../media/images/icons/bestcustomer.svg'



const WhyUs = () => {
  return (
    <div>
      <div className="why-us" id="why-us">
        <div className="why-us-main">
          <div className="why-us-label">Why Us?</div>
          <div className="why-us-heading">
            Why Choose RepairBuddy AC Repair Service?
          </div>
          <div className="why-us-content">

            
            <div className="why-us-content-col">
              {/* <div className="why-us-content-icon"><img src="https://static.onsitego.com/static/images/features/our_promise_banner/icons-qualified-engineers.webp?w=1920&q=75" alt="" /></div> */}
              <div className="why-us-content-icon"><img src={icon2} alt="" /></div>
              <div className="why-us-content-heading">Expert Technician</div>
              <div className="why-us-content-text">Our in-house AC experts have 10+ years of experience.</div>
            </div>

            
            <div className="why-us-content-col">
              {/* <div className="why-us-content-icon"><img src="https://static.onsitego.com/static/images/features/our_promise_banner/icons-qualified-engineers.webp?w=1920&q=75" alt="" /></div> */}
              <div className="why-us-content-icon"><img src={icon1} alt="" /></div> 
              <div className="why-us-content-heading">Quality Repairs</div>
              <div className="why-us-content-text">We use high-quality spare parts with a manufacturer warranty. Service comes with a 30-day guarantee.</div>
            </div>

            
            <div className="why-us-content-col">
              {/* <div className="why-us-content-icon"><img src="https://static.onsitego.com/static/images/features/our_promise_banner/icons-qualified-engineers.webp?w=1920&q=75" alt="" /></div> */}
              <div className="why-us-content-icon"><img src={icon3} alt="" /></div>
              <div className="why-us-content-heading">Trusted by Many</div>
              <div className="why-us-content-text">20,000+ happy customers trust our service.</div>
            </div>

            
          </div>



        <div className="cta-button">
              <a href="#book-now">Book Service Now</a>
            </div>

        </div>
        
      </div>
    </div>
  );
};

export default WhyUs;
